import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { Shield, Lock, Eye, Database, Mail } from 'lucide-react';

export const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <div className="pt-32 pb-20">
        <div className="container mx-auto px-4 max-w-4xl">
          <div className="mb-12">
            <span className="inline-block px-4 py-2 rounded-full bg-[#8B1538]/10 text-[#8B1538] text-sm font-semibold mb-4">
              Rechtliches
            </span>
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Datenschutzerklärung
            </h1>
            <p className="text-lg text-gray-600">
              Informationen zur Verarbeitung Ihrer Daten gemäß DSGVO
            </p>
          </div>

          <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-8 lg:p-12 space-y-8">
            {/* Verantwortlicher */}
            <div>
              <div className="flex items-center mb-4">
                <Shield className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">1. Verantwortlicher</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed">
                <p className="font-semibold">Verantwortlich für die Datenverarbeitung auf dieser Website ist:</p>
                <p className="mt-3">
                  Kalem Baustoffhandel<br />
                  Enes Cuhadar<br />
                  Waldseestr. 46<br />
                  63486 Bruchköbel
                </p>
                <p className="mt-3">
                  Telefon: <a href="tel:+4917912953010" className="text-[#8B1538] hover:underline">0179 / 12 95 310</a><br />
                  E-Mail: <a href="mailto:info@kalembaustoffe.de" className="text-[#8B1538] hover:underline">info@kalembaustoffe.de</a>
                </p>
              </div>
            </div>

            {/* Datenerfassung */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <Database className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">2. Allgemeine Hinweise zur Datenerfassung</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed space-y-4">
                <h3 className="font-semibold text-lg text-gray-900">Welche Daten werden erfasst?</h3>
                <p>
                  Wir erfassen Daten, die Sie uns aktiv mitteilen (z.B. über Kontaktformulare) sowie technische Daten, die automatisch beim Besuch der Website erfasst werden (z.B. IP-Adresse, Browser-Typ, Zugriffszeiten).
                </p>
                
                <h3 className="font-semibold text-lg text-gray-900 mt-6">Wofür nutzen wir Ihre Daten?</h3>
                <p>
                  Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden. Daten aus Kontaktformularen werden zur Bearbeitung Ihrer Anfrage genutzt.
                </p>

                <h3 className="font-semibold text-lg text-gray-900 mt-6">Welche Rechte haben Sie bezüglich Ihrer Daten?</h3>
                <p>
                  Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese jederzeit für die Zukunft widerrufen.
                </p>
              </div>
            </div>

            {/* Hosting */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <Lock className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">3. Hosting</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed space-y-4">
                <p>
                  Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v.a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
                </p>
                <p>
                  Das externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).
                </p>
              </div>
            </div>

            {/* Server-Log-Dateien */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <Eye className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">4. Server-Log-Dateien</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed space-y-4">
                <p>
                  Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
                </p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li>Browsertyp und Browserversion</li>
                  <li>Verwendetes Betriebssystem</li>
                  <li>Referrer URL</li>
                  <li>Hostname des zugreifenden Rechners</li>
                  <li>Uhrzeit der Serveranfrage</li>
                  <li>IP-Adresse</li>
                </ul>
                <p className="mt-4">
                  Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website.
                </p>
              </div>
            </div>

            {/* Kontaktformular */}
            <div className="border-t border-gray-200 pt-8">
              <div className="flex items-center mb-4">
                <Mail className="w-6 h-6 text-[#8B1538] mr-3" />
                <h2 className="text-2xl font-bold text-gray-900">5. Kontaktformular</h2>
              </div>
              <div className="ml-9 text-gray-700 leading-relaxed space-y-4">
                <p>
                  Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
                </p>
                <p>
                  Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO).
                </p>
                <p>
                  Die von Ihnen im Kontaktformular eingegebenen Daten verbleiben bei uns, bis Sie uns zur Löschung auffordern, Ihre Einwilligung zur Speicherung widerrufen oder der Zweck für die Datenspeicherung entfällt. Zwingende gesetzliche Bestimmungen – insbesondere Aufbewahrungsfristen – bleiben unberührt.
                </p>
              </div>
            </div>

            {/* Cookies */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Cookies</h2>
              <div className="text-gray-700 leading-relaxed space-y-4">
                <p>
                  Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.
                </p>
                <p>
                  Wir verwenden Cookies, um unser Angebot nutzerfreundlich zu gestalten. Einige Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Sie ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.
                </p>
                <p>
                  Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browsers aktivieren.
                </p>
              </div>
            </div>

            {/* Rechte der betroffenen Person */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Ihre Rechte</h2>
              <div className="text-gray-700 leading-relaxed space-y-4">
                <p>Sie haben folgende Rechte:</p>
                <ul className="list-disc list-inside space-y-2 ml-4">
                  <li><strong>Auskunftsrecht:</strong> Sie können Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten verlangen.</li>
                  <li><strong>Berichtigungsrecht:</strong> Sie können die Berichtigung unrichtiger Daten verlangen.</li>
                  <li><strong>Löschungsrecht:</strong> Sie können die Löschung Ihrer personenbezogenen Daten verlangen.</li>
                  <li><strong>Einschränkung der Verarbeitung:</strong> Sie können verlangen, dass wir die Verarbeitung Ihrer Daten einschränken.</li>
                  <li><strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung Ihrer Daten widersprechen.</li>
                  <li><strong>Datenübertragbarkeit:</strong> Sie können verlangen, dass wir Ihnen Ihre Daten in einem strukturierten Format übergeben.</li>
                  <li><strong>Beschwerderecht:</strong> Sie können sich bei einer Aufsichtsbehörde beschweren.</li>
                </ul>
                <p className="mt-6">
                  Für die Ausübung dieser Rechte wenden Sie sich bitte an:
                </p>
                <p>
                  E-Mail: <a href="mailto:info@kalembaustoffe.de" className="text-[#8B1538] hover:underline">info@kalembaustoffe.de</a><br />
                  Telefon: <a href="tel:+4917912953010" className="text-[#8B1538] hover:underline">0179 / 12 95 310</a>
                </p>
              </div>
            </div>

            {/* Widerruf */}
            <div className="border-t border-gray-200 pt-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Widerruf Ihrer Einwilligung</h2>
              <div className="text-gray-700 leading-relaxed">
                <p>
                  Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
                </p>
              </div>
            </div>

            {/* Stand */}
            <div className="border-t border-gray-200 pt-8">
              <p className="text-sm text-gray-500">
                Stand dieser Datenschutzerklärung: Dezember 2024
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};